// Wedding-O-Mat - Zentrale Konstanten (Frontend)
// Muss mit Backend-Konstanten synchron bleiben

export const CLIMATE = {
  TROPICAL: "tropisch & warm",
  MEDITERRANEAN: "mediterran & mild",
  TEMPERATE: "gemäßigt & kühl",
  DRY: "trocken & sonnig",
  ALPINE: "alpin & polar"
};

export const SCENARIOS = {
  BEACH: "Strand",
  RAINFOREST: "Regenwald",
  MOUNTAINS: "Berge",
  CITY: "City",
  DESERT: "Wüste"
};

export const CULTURAL_ASPECTS = {
  YOGA: "Yoga & Spiritualität",
  DANCE: "Tanz & Musik",
  CULINARY: "Kulinarik & Wein",
  ART: "Kunst & Design"
};

export const AMBIANCE = {
  RUSTIC: "Rustikal",
  MODERN: "Modern",
  EXOTIC: "Exotisch",
  ROYAL: "Royal"
};

export const ACCOMMODATION = {
  BOUTIQUE: "Boutique-Hotel",
  RESORT: "Resort",
  ECO_LODGE: "Eco-Lodge",
  AIRBNB: "AirBnB"
};

export const SEASONS = {
  JAN_FEB: "Januar-Februar",
  MAR_APR: "März-April",
  MAY_JUN: "Mai-Juni",
  JUL_AUG: "Juli-August",
  SEP_OCT: "September-Oktober",
  NOV_DEC: "November-Dezember"
};

export const DISTANCE = {
  NEAR: 1,
  MEDIUM: 2,
  FAR: 3,
  VERY_FAR: 4
};

export const GUEST_CAPACITY = {
  INTIMATE: "intimate",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

// Question-Answer Value Mappings
export const QUESTION_VALUES = {
  q6_guests: {
    'zu_zweit': 2,
    'ca_15': 15,
    'ca_25': 25,
    'ca_40': 40,
    'mehr_40': 50
  },
  q8_budget: {
    'bis_25k': 1,
    '25_40k': 2,
    '40_60k': 3,
    '60_90k': 4
  }
};

export const BUDGET_RANGES = {
  1: { min: 0, max: 25000, label: 'Bis 25.000€' },
  2: { min: 25001, max: 40000, label: '25.001€ - 40.000€' },
  3: { min: 40001, max: 60000, label: '40.001€ - 60.000€' },
  4: { min: 60001, max: 90000, label: '60.001€ - 90.000€' }
};
